import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LuCheck, LuClock3, LuMinus } from 'react-icons/lu';
import { SystemModelStatus } from '../../templates/modelStatus';

const STATUS_STYLES: Record<SystemModelStatus, string> = {
  approvato: 'bg-emerald-50 text-emerald-700',
  inRevisione: 'bg-amber-50 text-amber-700',
  nonInviato: 'bg-gray-100 text-gray-600',
};

const STATUS_ICONS: Record<SystemModelStatus, typeof LuCheck> = {
  approvato: LuCheck,
  inRevisione: LuClock3,
  nonInviato: LuMinus,
};

type ModelStatusBadgeProps = {
  status?: SystemModelStatus;
  skeleton?: boolean;
};

export const ModelStatusBadge: FC<ModelStatusBadgeProps> = ({ status, skeleton }) => {
  const { t } = useTranslation('comuni');

  if (skeleton) {
    return <span className='inline-block h-5 w-24 animate-pulse rounded-full bg-gray-100' aria-hidden />;
  }

  if (!status) return null;

  const Icon = STATUS_ICONS[status];

  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATUS_STYLES[status]}`}>
      <Icon className='size-3.5' aria-hidden />
      {t(`modelli.status.${status}`)}
    </span>
  );
};
